import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=b7c46296&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
